import type { SmartOLTDiagnosticsEvent } from "../../../services/smartolt.service.ts"

export const DIAGNOSTICS_TABS = [
  { id: "emergency_critical", label: "Emergency & Critical" },
  { id: "major", label: "Major" },
  { id: "medium", label: "Medium" },
  { id: "minor", label: "Minor" },
  { id: "unknown", label: "Unknown" },
] as const

export function formatDiagnosticDate(value?: string | null) {
  if (!value) return "—"
  const dt = new Date(value)
  if (Number.isNaN(dt.getTime())) return value
  return dt.toLocaleString(undefined, {
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  })
}

export function messageToneClass(tone?: string) {
  if (tone === "online") return "text-emerald-600"
  if (tone === "critical") return "text-rose-600"
  if (tone === "warning") return "text-amber-600"
  return "text-slate-600"
}

export function severityBadgeClass(severity: string) {
  const sev = severity.toLowerCase()
  if (sev === "emergency" || sev === "critical") return "bg-rose-50 text-rose-700"
  if (sev === "alert") return "bg-orange-50 text-orange-700"
  if (sev === "error") return "bg-red-50 text-red-700"
  if (sev === "warning") return "bg-amber-50 text-amber-800"
  if (sev === "notice" || sev === "informational") return "bg-sky-50 text-sky-700"
  return "bg-slate-100 text-slate-600"
}

export function filterEvents(events: SmartOLTDiagnosticsEvent[], search: string) {
  const q = search.trim().toLowerCase()
  if (!q) return events
  return events.filter((row) =>
    [row.olt_name, row.onu_name, row.message, row.ip_address, row.severity]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .includes(q),
  )
}
